import React from 'react'
import "./Orders.css";
import ProfileBanner from './ProfileBanner';
import { LiaArrowLeftSolid } from 'react-icons/lia';
import OrdersCard from './OrdersCard';
import { IoSearchOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';

const Orders = () => {
    const items = Array.from({ length: 6 })
    return (
        <>
            <ProfileBanner bannerName='My Orders' leftIcon={<LiaArrowLeftSolid />} rightIcon={""} />
            <section className='order-serach-main-sec'>
                <div className='container'>
                    <div className='order-serach-main-div '>
                        <div className='order-serach-search-icon pr-5'> <IoSearchOutline /></div>
                        <div>
                            <input className='order-serach-main-input-tag' type='text' placeholder='Search in orders' />
                        </div>
                    </div>
                </div>
            </section>
            <section className='order-serach-main-order-card-sec'>
                <div className=''>
                    {items?.map((_, i) => (
                        <Link to='/order-details'>
                            <OrdersCard />
                        </Link>
                    ))}
                </div>
            </section>
        </>
    )
}

export default Orders